import { IconProps } from './icon';

export function IconLinkedin({
  size = '100%',
  fill = 'currentColor',
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_655_1408)">
        <path
          d="M14.8156 0.851196H1.18125C0.528125 0.851196 0 1.36682 0 2.00432V15.6949C0 16.3324 0.528125 16.8512 1.18125 16.8512H14.8156C15.4688 16.8512 16 16.3324 16 15.6981V2.00432C16 1.36682 15.4688 0.851196 14.8156 0.851196ZM4.74687 14.4856H2.37188V6.84807H4.74687V14.4856ZM3.55938 5.80745C2.79688 5.80745 2.18125 5.19182 2.18125 4.43245C2.18125 3.67307 2.79688 3.05745 3.55938 3.05745C4.31875 3.05745 4.93437 3.67307 4.93437 4.43245C4.93437 5.1887 4.31875 5.80745 3.55938 5.80745ZM13.6344 14.4856H11.2625V10.7731C11.2625 9.8887 11.2469 8.74807 10.0281 8.74807C8.79375 8.74807 8.60625 9.7137 8.60625 10.7106V14.4856H6.2375V6.84807H8.5125V7.89182H8.54375C8.85938 7.29182 9.63438 6.65745 10.7875 6.65745C13.1906 6.65745 13.6344 8.2387 13.6344 10.2949V14.4856Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_655_1408">
          <rect
            width="16"
            height="16"
            fill={fill}
            transform="translate(0 0.851196)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
